import { API } from '@Providers';

export default async function (type: string, outcomeType?: string) {
  const payload = { type, outcome_type: outcomeType };
  const endpoint = '/api/shelter/settings/get-waiver-templates';

  return API({ endpoint, method: 'post', payload });
}
